export default "__VITE_ASSET__5a651c62__$_?component__"